export { PermanentlySortedList } from "./PermanentlySortedList.js";

/**
 * 2:30 pm in different format strings:
 * hh:mm nn -> 02:30 pm
 * HH:mm NN -> 14:30 PM
 * h:mm nn -> 2:30 pm
 * ss is seconds
 * @param {Date} time
 * @param formatString
 * @return {string}
 */
export function getTimeString(time: Date, formatString: string): string {
    const milHours = time.getHours();
    const minutes = time.getMinutes();
    let ampm = "am";
    let AMPM = "AM";
    let standHours = milHours;
    if (milHours >= 12) {
        ampm = "pm";
        AMPM = "PM";
    }
    if (milHours > 12) {
        standHours = milHours - 12;
    }
    formatString = formatString.replace(/hh/g, standHours.toString().padStart(2, "0"));
    formatString = formatString.replace(/HH/g, milHours.toString().padStart(2, "0"));
    formatString = formatString.replace(/H/g, milHours.toString());
    formatString = formatString.replace(/h/g, standHours.toString());

    formatString = formatString.replace(/mm/g, minutes.toString().padStart(2, "0"));
    formatString = formatString.replace(/ss/g, time.getSeconds.toString().padStart(2, "0"));
    formatString = formatString.replace(/nn/g, ampm);
    formatString = formatString.replace(/NN/g, AMPM);
    return formatString;
}

/**
 * Converts weekday options from JavaScript Date convention to RRule convention.
 *
 * JavaScript Date.getDay() uses: 0=Sunday, 1=Monday, ..., 6=Saturday
 * RRule byweekday uses: 0=Monday, 1=Tuesday, ..., 6=Sunday
 *
 * The conversion formula is: rruleDay = (jsDay - 1 + 7) % 7
 *
 * Note: This function does NOT adjust for timezone differences between local and UTC.
 * The caller is responsible for ensuring that the startTime Date and weekday values
 * are in the same timezone context.
 *
 * @param startTime - The start time for the recurrence rule
 * @param JSrruleOptions - Options with weekdays in JS convention
 * @return Options with weekdays converted to RRule convention
 */
export function jsOptionstoRRuleOptions(startTime, JSrruleOptions: { byweekday: number[]; dtstart: Date }) {
    const newOptions = { ...JSrruleOptions };
    if (JSrruleOptions.byweekday) {
        const newDaysList = [...JSrruleOptions.byweekday];
        // Convert from JS convention (0=Sun, 1=Mon, ..., 6=Sat) to RRule convention (0=Mon, 1=Tue, ..., 6=Sun)
        const dayDiff = -1;
        newDaysList.forEach((v, i) => {
            newDaysList[i] = (v + dayDiff + 7) % 7;
        });
        newOptions.dtstart = startTime;
        newOptions.byweekday = newDaysList;
    }
    newOptions.dtstart = startTime;
    return newOptions;
}
/**
 * Converts weekday options from RRule convention back to JavaScript Date convention.
 *
 * RRule byweekday uses: 0=Monday, 1=Tuesday, ..., 6=Sunday
 * JavaScript Date.getDay() uses: 0=Sunday, 1=Monday, ..., 6=Saturday
 *
 * The conversion formula is: jsDay = (rruleDay + 1) % 7
 *
 * Note: This function does NOT adjust for timezone differences between local and UTC.
 * The caller is responsible for ensuring timezone consistency.
 *
 * @param startTime - The start time for the recurrence rule
 * @param rruleOptions - Options with weekdays in RRule convention
 * @return Options with weekdays converted to JS convention
 */
export function rruleOptionstoJSOptions(startTime, rruleOptions: { byweekday: number[]; dtstart: Date }) {
    const newOptions = { ...rruleOptions };
    startTime = startTime || new Date(new Date(rruleOptions.dtstart).valueOf());
    if (rruleOptions) {
        if (rruleOptions.byweekday) {
            const newDaysList = [...rruleOptions.byweekday];
            newOptions.byweekday = newDaysList;
            // Convert from RRule convention (0=Mon, 1=Tue, ..., 6=Sun) to JS convention (0=Sun, 1=Mon, ..., 6=Sat)
            const dayDiff = 1;
            newDaysList.forEach((v, i) => {
                newDaysList[i] = (v + dayDiff + 7) % 7;
            });
        }
        newOptions.dtstart = startTime;
    } else {
        throw new Error("No rrule options provided");
    }
    return newOptions;
}
